import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { WHATSAPP_LINK } from "@/lib/translations";
import { MessageCircle } from "lucide-react";

export default function WhatsAppButton() {
  const { t } = useLanguage();
  return (
    <a
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t.whatsapp_aria}
      data-testid="whatsapp-float-btn"
      className="fixed bottom-6 right-6 z-40 group flex items-center gap-2 rounded-full pl-4 pr-5 py-3 shadow-lg shadow-brand-primary/25 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl"
      style={{ backgroundColor: "#25D366" }}
    >
      <MessageCircle className="text-white" size={22} />
      <span className="hidden sm:inline text-white text-sm font-semibold tracking-wide">WhatsApp</span>
      <span className="absolute inline-flex h-3 w-3 -top-0.5 -right-0.5">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-60"></span>
        <span className="relative inline-flex rounded-full h-3 w-3 bg-white"></span>
      </span>
    </a>
  );
}
